/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon16Regular = forwardRef('TextArticleTIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.75 1.25a.75.75 0 0 0 0 1.5h1.5V6a.75.75 0 0 0 1.5 0V2.75h1.5a.75.75 0 0 0 0-1.5h-4.5Z" }),
        React.createElement("path", { d: "M8.75 2.25a.75.75 0 0 0 0 1.5H13a.75.75 0 0 0 0-1.5H8.75Z" }),
        React.createElement("path", { d: "M8 6a.75.75 0 0 1 .75-.75H13a.75.75 0 0 1 0 1.5H8.75A.75.75 0 0 1 8 6Z" }),
        React.createElement("path", { d: "M3 8.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M3 11.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H3Z" })));
});
